module.exports = __webpack_public_path__ + "media/application/images/ui/badge-peoples-choice-xs-f387b02b70d3a0f71a3d7bb84035cca1.png";